<template lang="pug">
  div
    v-card
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title
          h1.subheading {{ $t('pageHeader.promotion') }}
      v-card-title
        v-flex(xs12 md4)
          v-text-field(v-model='search', append-icon='search', label='Search', single-line, hide-details clearable)

      v-data-table(:headers='headers' item-key="promotion_Id" :items='promotion' :search="search" :loading='loading' :pagination.sync='pagination')
        template(slot='items' slot-scope='props')
          tr.pointer
            td.text-xs-left(@click="props.expanded = !props.expanded") {{ props.item.promotion_Id }}
            td.text-xs-left(@click="props.expanded = !props.expanded") {{ $moment(props.item.createdAt).format('MM/DD/YYYY h:m a') }}
            td.text-xs-left(@click="props.expanded = !props.expanded") {{ props.item.messageType }}
            td.text-xs-left(@click="props.expanded = !props.expanded") {{ props.item.sentCount }}
            td.text-xs-left(@click="props.expanded = !props.expanded") {{ props.item.status }}
            
        template(slot='expand' slot-scope='props')
          v-card
            v-card-text
              v-layout(row wrap)
                v-flex(xs12 sm6)
                  h3.font-weight-regular.mb-3 Promotion
                  div 
                    span.mr-1 {{ $t('labels.sendCount') }}: 
                    span.font-weight-medium {{ props.item.sentCount }}
                  div
                    span.mr-1 {{ $t('labels.deliverdCount') }}:
                    span.font-weight-medium {{ props.item.deliveredCount }}
                  div
                    span.mr-1 {{ $t('labels.costPrice') }}:
                    span.font-weight-medium {{ props.item.costPrice | currency }}
                  div
                    span.mr-1 {{ $t('labels.initialHoldingValue') }}:
                    span.font-weight-medium {{ props.item.initialHoldValue | currency }}
                  div
                    span.mr-1 {{ $t('labels.afterDeliveredValue') }}:
                    span.font-weight-medium {{ props.item.afterDeliveredValue | currency }}
                v-flex(xs12 sm6)
                  h3.font-weight-regular.mb-3 Message
                  div.mt-1 {{ $t('labels.status') }}
                  div.font-weight-medium {{ props.item.status }}
                  div.mt-1 {{ $t('labels.message') }}
                  div.font-weight-medium {{ props.item.message }}
                  div.mt-1(v-if="props.item.mediaUrl") {{ $t('labels.imageURL') }}
                  div.font-weight-medium(v-if="props.item.mediaUrl") {{ props.item.mediaUrl }}

        v-alert(slot='no-results', :value='true', color='error', icon='warning')
          | Your search for "{{ search }}" found no results.
      

</template>


<script>
import promotionService from '../service.js'
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      createDialog: false,
      expand: false,
      headers: [
        {
          text: this.$t('labels.id'),
          value: 'createdID',
          sortable: true,
          width: '5%',
        },
        {
          text: this.$t('labels.createdAt'),
          value: 'createDateTime',
          sortable: true,
        },
        {
          text: this.$t('labels.messageType'),
          value: 'userName',
          sortable: true,
        },
        {
          text: this.$t('labels.sendCount'),
          value: 'sentCount',
          sortable: true,
        },
        {
          text: this.$t('labels.status'),
          value: 'refID.fullName',
          sortable: true,
        },
      ],
      search: null,
      promotion: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'promotion_Id',
        descending: true,
      },
    }
  },
  computed: {
    ...mapGetters('location', ['location']),
  },
  created() {
    this.getByStoreId()
  },
  watch: {
    location() {
      this.getByStoreId()
    }
  },
  methods: {
    ...mapActions('global', ['setPageTitle']),
    getByStoreId() {
      this.loading = true
      return promotionService
      .getByStoreId(this.location.storeID)
      .then((response) => {
        this.promotion = response.data
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
</style>